import { useMemo, useState } from 'react';
import { useGetConnectionPathsQuery } from '../../../../services/connectionPathsV2';

export function useConnectionPaths({ contact }) {
  const { data = [], isFetching } = useGetConnectionPathsQuery({ contactId: contact.id });
  const [showAll, setShowAll] = useState(false);

  const { initialCount, itemsToRender, hasMore } = useMemo(() => {
    const initial = Math.min(5, data.length);
    const items = showAll ? data : data.slice(0, initial);
    const more = data.length > initial;
    return { initialCount: initial, itemsToRender: items, hasMore: more };
  }, [data, showAll]);

  return {
    data,
    isFetching,
    showAll,
    setShowAll,
    initialCount,
    itemsToRender,
    hasMore,
  };
}
